import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

// 获取活动列表
export function listActivitiesSignUp(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/activitiesSignUp.listActivitiesSignUps',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve({
        data: res.activitiesSignUps,
        total: res.total
      })
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取活动详情
export function getActivitiesSignUpDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/activitiesSignUp.listActivitiesSignUps',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加活动
export function saveActivities(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/activities.saveActivities',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新活动
export function updateActivities(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/activities.updateActivities',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新活动报名
export function updateActivitiesSignUp(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/activitiesSignUp.updateActivitiesSignUp',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除活动
export function deleteActivitiesSignUp(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/activitiesSignUp.deleteActivitiesSignUp',
      method: 'post',
      data: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取活动类型列表
export function listActivitiesType(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/activitiesType/queryActivitiesType',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve({
        data: res.data
      })
    }).catch(error => {
      reject(error)
    })
  })
}

// 上传图片
export function uploadImage(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/uploadFile/uploadImage',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}